import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListGroupsComponent } from './list-groups/list-groups.component';
import { CreateGroupComponent } from './create-group/create-group.component';
import { GroupUserComponent } from './group-users/group-users.component';



const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-group',
        component: ListGroupsComponent,
        data: {
          title: "Group List",
          breadcrumb: "Group List"
        }
      },
      {
        path: 'create-group',
        component: CreateGroupComponent,
        data: {
          title: "Crear grupo",
          breadcrumb: "Crear grupos"
        }
      },
      {
        path: 'group-user/:id',
        component: GroupUserComponent,
        data: {
          title: "Grupo - Usuarios",
          breadcrumb: "Grupo - Usuarios"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupsRoutingModule { }
